import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LIBERTY_IMAGES } from '../assets/asset'
import TokenSelector from '../components/TokenSelector'

const PRIVATE_EXCHANGE_PAY_INIT = {
    symbol: 'USDC',
    chain: 'Ethereum',
    image: LIBERTY_IMAGES.USDC,
    chainBadge: LIBERTY_IMAGES.IC_RAILGUN_LOG,
    showRailgunSuffix: true,
}

const PRIVATE_EXCHANGE_RECEIVE_INIT = {
    symbol: 'USDC',
    chain: 'PulseChain',
    image: LIBERTY_IMAGES.USDC,
    chainBadge: LIBERTY_IMAGES.PULSECHAIN,
    showRailgunSuffix: false,
}

function PrivateExchangeTokenPill({ token, onOpen }) {
    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onOpen}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    onOpen()
                }
            }}
            className="inline-flex flex-col items-center justify-between bg-[var(--exchange-secondary-mobile)] md:bg-[var(--exchange-secondary-desktop)] py-1.5 md:py-1 px-2 rounded-full cursor-pointer hover:bg-[#333333]
  font-medium whitespace-nowrap self-start w-full justify-between"
        >
            <div className="flex items-center gap-2 w-full">
                <div className="flex items-center w-full">
                    <div className="relative mr-2">
                        <img
                            alt={token.symbol}
                            loading="lazy"
                            width={32}
                            height={32}
                            decoding="async"
                            data-nimg={1}
                            className="border border-[#393941] rounded-full"
                            src={token.image}
                            style={{ color: 'transparent' }}
                        />
                        <div className="absolute -bottom-1 -right-1">
                            <img
                                alt={token.chain}
                                loading="lazy"
                                width={16}
                                height={16}
                                decoding="async"
                                data-nimg={1}
                                className="border border-[#393941] rounded-full"
                                src={token.chainBadge}
                                style={{ color: 'transparent' }}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col items-start md:mr-2">
                        <span className="text-[#F7F7F8] font-medium text-base">
                            {token.symbol}
                            {token.showRailgunSuffix ? (
                                <span className="text-[#F5A425]"> · RAILGUN</span>
                            ) : null}
                        </span>
                        <span className="text-[#9091A0] text-xs md:block block">{token.chain}</span>
                    </div>
                    <img
                        alt="Chevron Down"
                        loading="lazy"
                        width={20}
                        height={20}
                        decoding="async"
                        data-nimg={1}
                        className="ml-auto flex-shrink-0"
                        src={LIBERTY_IMAGES.IC_CHEVRON_DOWN}
                        style={{ color: 'transparent' }}
                    />
                </div>
            </div>
        </div>
    )
}

const PrivateExchange = () => {
    const navigate = useNavigate()
    const [tokenSelectorOpen, setTokenSelectorOpen] = useState(false)
    const [tokenPickerField, setTokenPickerField] = useState('pay')
    const [payToken, setPayToken] = useState(PRIVATE_EXCHANGE_PAY_INIT)
    const [receiveToken, setReceiveToken] = useState(PRIVATE_EXCHANGE_RECEIVE_INIT)

    const openPayTokenPicker = () => {
        setTokenPickerField('pay')
        setTokenSelectorOpen(true)
    }

    const openReceiveTokenPicker = () => {
        setTokenPickerField('receive')
        setTokenSelectorOpen(true)
    }

    return (
        <>
            <main className="pt-16 md:pt-20 pb-16 md:pb-0">
                {/*$*/}
                {/*/$*/}
                <div className="min-h-[calc(100vh-64px)] md:min-h-[calc(100vh-72px)] flex items-center justify-center py-4 md:py-6">
                    <div className="w-full max-w-[600px] px-4 md:px-6">
                        <div className="md:hidden">
                            <div className="relative">
                                <div className="relative z-10">
                                    <div className="flex justify-between items-center text-center mb-4">
                                        <span className="hidden md:block text-2xl italic font-soloist">
                                            PRIVATE MODE
                                        </span>
                                        <span className="md:hidden text-2xl italic font-soloist">
                                            EXCHANGE
                                        </span>
                                        <div className="flex items-center bg-[#242429] rounded-full p-1 gap-1">
                                            <button
                                                className="rounded-full transition-all duration-200 "
                                                style={{}}
                                                onClick={() => navigate('/')}
                                            >
                                                <div
                                                    className="flex items-center gap-1 pl-[6px] pr-[10px] py-[2px] rounded-full transition-all duration-200 text-gray-400 bg-[#242429] hover:text-gray-300"
                                                    style={{}}
                                                >
                                                    <img
                                                        alt="Public"
                                                        loading="lazy"
                                                        width={16}
                                                        height={16}
                                                        decoding="async"
                                                        data-nimg={1}
                                                        className="opacity-50"
                                                        src={LIBERTY_IMAGES.IC_GLOBAL}
                                                        style={{ color: "transparent" }}
                                                    />
                                                    <span className="font-medium">Public</span>
                                                </div>
                                            </button>
                                            <button
                                                className="rounded-full transition-all duration-200 p-[1px]"
                                                style={{
                                                    background:
                                                        "linear-gradient(rgb(53, 38, 2) 0%, rgb(220, 169, 43) 100%)"
                                                }}
                                                onClick={() => navigate('/private-exchange')}
                                            >
                                                <div
                                                    className="flex items-center gap-1 pl-[6px] pr-[10px] py-[2px] rounded-full transition-all duration-200 text-white font-semibold"
                                                    style={{
                                                        background:
                                                            "linear-gradient(92.32deg, rgb(219, 166, 36) 1.79%, rgb(101, 73, 1) 99.58%)"
                                                    }}
                                                >
                                                    <img
                                                        alt="Private"
                                                        loading="lazy"
                                                        width={16}
                                                        height={16}
                                                        decoding="async"
                                                        data-nimg={1}
                                                        className="brightness-0 invert"
                                                        src={LIBERTY_IMAGES.IC_SHIELD_TICK}
                                                        style={{ color: "transparent" }}
                                                    />
                                                    <span className="font-medium">Private</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="flex flex-col md:flex-row items-center md:gap-4 w-full md:bg-[var(--exchange-bg-desktop)] rounded-xl md:p-4">
                                        <div className="flex flex-col gap-1.5 w-full md:flex-1 min-w-0 bg-[var(--exchange-bg-mobile)] md:bg-transparent rounded-xl p-4 pb-8 md:p-0">
                                            <span className="text-[#9091A0] text-sm font-medium">
                                                You Pay
                                            </span>
                                            <button
                                                type="button"
                                                className="w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F5A425] focus-visible:ring-offset-2 focus-visible:ring-offset-[#18181B] rounded-full"
                                            >
                                                <PrivateExchangeTokenPill
                                                    token={payToken}
                                                    onOpen={openPayTokenPicker}
                                                />
                                            </button>
                                        </div>
                                        <img
                                            alt="Arrow Right"
                                            loading="lazy"
                                            width={20}
                                            height={20}
                                            decoding="async"
                                            data-nimg={1}
                                            className="hidden md:block mt-[26px]"
                                            src={LIBERTY_IMAGES.IC_ARROW_RIGHT}
                                            style={{ color: "transparent" }}
                                        />
                                        <div className="block md:hidden p-1 bg-[#242429] rounded-xl border border-[#393941] mt-[-12px] mb-[-16px] z-10">
                                            <img
                                                alt="Arrow Down"
                                                loading="lazy"
                                                width={24}
                                                height={24}
                                                decoding="async"
                                                data-nimg={1}
                                                src={LIBERTY_IMAGES.IC_ARROW_DOWN}
                                                style={{ color: "transparent" }}
                                            />
                                        </div>
                                        <div className="flex flex-col gap-1.5 w-full md:flex-1 min-w-0 bg-[var(--exchange-bg-mobile)] md:bg-transparent rounded-xl p-4 pt-8 md:p-0">
                                            <span className="text-[#9091A0] text-sm font-medium">
                                                You Receive
                                            </span>
                                            <button
                                                type="button"
                                                className="w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F5A425] focus-visible:ring-offset-2 focus-visible:ring-offset-[#18181B] rounded-full"
                                            >
                                                <PrivateExchangeTokenPill
                                                    token={receiveToken}
                                                    onOpen={openReceiveTokenPicker}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mt-4 p-4 bg-[var(--exchange-bg-mobile)] md:bg-[var(--exchange-bg-desktop)] rounded-xl space-y-2 text-sm">
                                        <div className="flex justify-between items-center mb-3">
                                            <div className="flex items-center gap-1">
                                                <span className="text-[#F5A425] font-bold pt-0.5 antialiased text-sm">
                                                    EVM Wallet Address to receive funds
                                                </span>
                                                <button
                                                    type="button"
                                                    className="rounded hover:bg-[var(--exchange-hover-mobile)] md:hover:bg-[var(--exchange-hover-desktop)] transition"
                                                    aria-label="Show address information"
                                                >
                                                    <div className="p-1 bg-[#FFFFFF]/5 rounded-full">
                                                        <img
                                                            alt="Info"
                                                            loading="lazy"
                                                            width={16}
                                                            height={16}
                                                            decoding="async"
                                                            data-nimg={1}
                                                            src={LIBERTY_IMAGES.IC_FILL_INFORMATION}
                                                            style={{ color: "transparent" }}
                                                        />
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="relative">
                                            <input
                                                placeholder="Enter destination address"
                                                className="w-full bg-[var(--exchange-secondary-mobile)] md:bg-[var(--exchange-secondary-desktop)] rounded-lg p-3 pr-12 text-white placeholder:text-gray-500 outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-0 transition-all duration-200 text-base"
                                                type="text"
                                                defaultValue=""
                                            />
                                        </div>
                                    </div>
                                    <div className="bg-[var(--exchange-bg-mobile)] md:bg-[var(--exchange-bg-desktop)] rounded-xl p-4 space-y-3 text-sm mt-4">
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-400">Rate</span>
                                            <span className="text-white">1 : 1 USDC</span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-400">Estimated time</span>
                                            <span className="text-white">2-3 min</span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-400">Protocol fee</span>
                                            <span className="text-white">0 USDC (0.5%)</span>
                                        </div>
                                    </div>
                                    <div className="mt-6">
                                        <button
                                            className="rounded-xl font-medium transition-all duration-300 cursor-pointer text-white hover:opacity-90 px-6 py-3 text-base w-full   "
                                            style={{ background: "var(--gradient-3)" }}
                                        >
                                            Swap
                                        </button>
                                    </div>
                                    <div className="mt-4">
                                        <div className="flex items-center justify-center gap-1.5 cursor-pointer hover:opacity-80 transition-opacity duration-200">
                                            <img
                                                alt="Coffee"
                                                loading="lazy"
                                                width={20}
                                                height={20}
                                                decoding="async"
                                                data-nimg={1}
                                                src={LIBERTY_IMAGES.IC_HEART_CUM}
                                                style={{ color: "transparent" }}
                                            />
                                            <span className="text-[#F5A425] font-medium text-sm">
                                                Buy us a coffee
                                            </span>
                                            <img
                                                alt="Arrow"
                                                loading="lazy"
                                                width={21}
                                                height={20}
                                                decoding="async"
                                                data-nimg={1}
                                                src={LIBERTY_IMAGES.IC_ARROW_UP_RIGHT_1}
                                                style={{ color: "transparent" }}
                                            />
                                        </div>
                                    </div>
                                    <div className="hidden md:block bg-[var(--exchange-bg-mobile)] md:bg-[var(--exchange-bg-desktop)] px-4 py-3 flex flex-col items-center justify-center mt-6 -mx-6 w-[calc(100%+3rem)]">
                                        <div className="text-center text-sm text-neutral-400">
                                            Smart Contract is currently in beta.{" "}
                                            <button className="text-[#F5A425] hover:text-amber-400 transition-colors underline">
                                                Learn more
                                            </button>
                                        </div>
                                    </div>
                                    <div className="md:hidden mt-2">
                                        <div className="text-center text-sm text-neutral-400">
                                            Smart Contract is currently in beta.{" "}
                                            <button className="text-[#F5A425] hover:text-amber-400 transition-colors underline">
                                                Learn more
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="absolute -top-4 -left-4 -right-4 h-full z-0"
                                    style={{
                                        pointerEvents: "none",
                                        backgroundImage: `url(${LIBERTY_IMAGES.SHIELD_GRADIENT_BG})`,
                                        backgroundSize: "100%",
                                        backgroundPosition: "center top",
                                        backgroundRepeat: "no-repeat"
                                    }}
                                />
                            </div>
                        </div>
                        <div className="hidden md:block">
                            <div
                                className="pt-4 md:pt-6 pr-4 md:pr-6 pl-4 md:pl-6 w-full max-w-[600px] overflow-hidden rounded-xl bg-[#18181B]"
                                style={{
                                    backgroundImage: `url(${LIBERTY_IMAGES.SHIELD_GRADIENT_BG})`,
                                    backgroundSize: "100%",
                                    backgroundPosition: "center top",
                                    backgroundRepeat: "no-repeat"
                                }}
                            >
                                <div className="flex justify-between items-center text-center mb-4">
                                    <span className="hidden md:block text-2xl italic font-soloist">
                                        PRIVATE MODE
                                    </span>
                                    <span className="md:hidden text-2xl italic font-soloist">
                                        EXCHANGE
                                    </span>
                                    <div className="flex items-center bg-[#242429] rounded-full p-1 gap-1">
                                        <button
                                            className="rounded-full transition-all duration-200 "
                                            style={{}}
                                            onClick={() => navigate('/')}
                                        >
                                            <div
                                                className="flex items-center gap-1 pl-[6px] pr-[10px] py-[2px] rounded-full transition-all duration-200 text-gray-400 bg-[#242429] hover:text-gray-300"
                                                style={{}}
                                            >
                                                <img
                                                    alt="Public"
                                                    loading="lazy"
                                                    width={16}
                                                    height={16}
                                                    decoding="async"
                                                    data-nimg={1}
                                                    className="opacity-50"
                                                    src={LIBERTY_IMAGES.IC_GLOBAL}
                                                    style={{ color: "transparent" }}
                                                />
                                                <span className="font-medium">Public</span>
                                            </div>
                                        </button>
                                        <button
                                            className="rounded-full transition-all duration-200 p-[1px]"
                                            style={{
                                                background:
                                                    "linear-gradient(rgb(53, 38, 2) 0%, rgb(220, 169, 43) 100%)"
                                            }}
                                            onClick={() => navigate('/private-exchange')}
                                        >
                                            <div
                                                className="flex items-center gap-1 pl-[6px] pr-[10px] py-[2px] rounded-full transition-all duration-200 text-white font-semibold"
                                                style={{
                                                    background:
                                                        "linear-gradient(92.32deg, rgb(219, 166, 36) 1.79%, rgb(101, 73, 1) 99.58%)"
                                                }}
                                            >
                                                <img
                                                    alt="Private"
                                                    loading="lazy"
                                                    width={16}
                                                    height={16}
                                                    decoding="async"
                                                    data-nimg={1}
                                                    className="brightness-0 invert"
                                                    src={LIBERTY_IMAGES.IC_SHIELD_TICK}
                                                    style={{ color: "transparent" }}
                                                />
                                                <span className="font-medium">Private</span>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                <div className="flex flex-col md:flex-row items-center md:gap-4 w-full md:bg-[var(--exchange-bg-desktop)] rounded-xl md:p-4">
                                    <div className="flex flex-col gap-1.5 w-full md:flex-1 min-w-0 bg-[var(--exchange-bg-mobile)] md:bg-transparent rounded-xl p-4 pb-8 md:p-0">
                                        <span className="text-[#9091A0] text-sm font-medium">
                                            You Pay
                                        </span>
                                        <button
                                            type="button"
                                            className="w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F5A425] focus-visible:ring-offset-2 focus-visible:ring-offset-[#18181B] rounded-full"
                                        >
                                            <PrivateExchangeTokenPill
                                                token={payToken}
                                                onOpen={openPayTokenPicker}
                                            />
                                        </button>
                                    </div>
                                    <img
                                        alt="Arrow Right"
                                        loading="lazy"
                                        width={20}
                                        height={20}
                                        decoding="async"
                                        data-nimg={1}
                                        className="hidden md:block mt-[26px]"
                                        src={LIBERTY_IMAGES.IC_ARROW_RIGHT}
                                        style={{ color: "transparent" }}
                                    />
                                    <div className="block md:hidden p-1 bg-[#242429] rounded-xl border border-[#393941] mt-[-12px] mb-[-16px] z-10">
                                        <img
                                            alt="Arrow Down"
                                            loading="lazy"
                                            width={24}
                                            height={24}
                                            decoding="async"
                                            data-nimg={1}
                                            src={LIBERTY_IMAGES.IC_ARROW_DOWN}
                                            style={{ color: "transparent" }}
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1.5 w-full md:flex-1 min-w-0 bg-[var(--exchange-bg-mobile)] md:bg-transparent rounded-xl p-4 pt-8 md:p-0">
                                        <span className="text-[#9091A0] text-sm font-medium">
                                            You Receive
                                        </span>
                                        <button
                                            type="button"
                                            className="w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F5A425] focus-visible:ring-offset-2 focus-visible:ring-offset-[#18181B] rounded-full"
                                        >
                                            <PrivateExchangeTokenPill
                                                token={receiveToken}
                                                onOpen={openReceiveTokenPicker}
                                            />
                                        </button>
                                    </div>
                                </div>
                                <div className="mt-4 p-4 bg-[var(--exchange-bg-mobile)] md:bg-[var(--exchange-bg-desktop)] rounded-xl space-y-2 text-sm">
                                    <div className="flex justify-between items-center mb-3">
                                        <div className="flex items-center gap-1">
                                            <span className="text-[#F5A425] font-bold pt-0.5 antialiased text-sm">
                                                EVM Wallet Address to receive funds
                                            </span>
                                            <button
                                                type="button"
                                                className="rounded hover:bg-[var(--exchange-hover-mobile)] md:hover:bg-[var(--exchange-hover-desktop)] transition"
                                                aria-label="Show address information"
                                            >
                                                <div className="p-1 bg-[#FFFFFF]/5 rounded-full">
                                                    <img
                                                        alt="Info"
                                                        loading="lazy"
                                                        width={16}
                                                        height={16}
                                                        decoding="async"
                                                        data-nimg={1}
                                                        src={LIBERTY_IMAGES.IC_FILL_INFORMATION}
                                                        style={{ color: "transparent" }}
                                                    />
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="relative">
                                        <input
                                            placeholder="Enter destination address"
                                            className="w-full bg-[var(--exchange-secondary-mobile)] md:bg-[var(--exchange-secondary-desktop)] rounded-lg p-3 pr-12 text-white placeholder:text-gray-500 outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-0 transition-all duration-200 text-base"
                                            type="text"
                                            defaultValue=""
                                        />
                                    </div>
                                </div>
                                <div className="bg-[var(--exchange-bg-mobile)] md:bg-[var(--exchange-bg-desktop)] rounded-xl p-4 space-y-3 text-sm mt-4">
                                    <div className="flex justify-between items-center">
                                        <span className="text-gray-400">Rate</span>
                                        <span className="text-white">1 : 1 USDC</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-gray-400">Estimated time</span>
                                        <span className="text-white">2-3 min</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-gray-400">Protocol fee</span>
                                        <span className="text-white">0 USDC (0.5%)</span>
                                    </div>
                                </div>
                                <div className="mt-6">
                                    <button
                                        className="rounded-xl font-medium transition-all duration-300 cursor-pointer text-white hover:opacity-90 px-6 py-3 text-base w-full   "
                                        style={{ background: "var(--gradient-3)" }}
                                    >
                                        Swap
                                    </button>
                                </div>
                                <div className="mt-4">
                                    <div className="flex items-center justify-center gap-1.5 cursor-pointer hover:opacity-80 transition-opacity duration-200">
                                        <img
                                            alt="Coffee"
                                            loading="lazy"
                                            width={20}
                                            height={20}
                                            decoding="async"
                                            data-nimg={1}
                                            src={LIBERTY_IMAGES.IC_HEART_CUM}
                                            style={{ color: "transparent" }}
                                        />
                                        <span className="text-[#F5A425] font-medium text-sm">
                                            Buy us a coffee
                                        </span>
                                        <img
                                            alt="Arrow"
                                            loading="lazy"
                                            width={21}
                                            height={20}
                                            decoding="async"
                                            data-nimg={1}
                                            src={LIBERTY_IMAGES.IC_ARROW_UP_RIGHT_1}
                                            style={{ color: "transparent" }}
                                        />
                                    </div>
                                </div>
                                <div className="hidden md:block bg-[var(--exchange-bg-mobile)] md:bg-[var(--exchange-bg-desktop)] px-4 py-3 flex flex-col items-center justify-center mt-6 -mx-6 w-[calc(100%+3rem)]">
                                    <div className="text-center text-sm text-neutral-400">
                                        Smart Contract is currently in beta.{" "}
                                        <button className="text-[#F5A425] hover:text-amber-400 transition-colors underline">
                                            Learn more
                                        </button>
                                    </div>
                                </div>
                                <div className="md:hidden mt-2">
                                    <div className="text-center text-sm text-neutral-400">
                                        Smart Contract is currently in beta.{" "}
                                        <button className="text-[#F5A425] hover:text-amber-400 transition-colors underline">
                                            Learn more
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex-shrink-0 snap-center mt-6">
                            <div className="bg-[var(--exchange-bg-mobile)] md:bg-[var(--exchange-bg-desktop)] rounded-xl px-6 py-3 border border-white/[0.03] flex items-center justify-between">
                                <div className="flex flex-col">
                                    <p className="text-white font-medium text-base">
                                        Our Integrations Powered by...
                                    </p>
                                </div>
                                <div className="flex items-center">
                                    <img
                                        alt="partner"
                                        loading="lazy"
                                        width={125}
                                        height={40}
                                        decoding="async"
                                        data-nimg={1}
                                        className="object-contain"
                                        src={LIBERTY_IMAGES.ALL_PARTNER}
                                        style={{ color: "transparent" }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mt-8 text-center text-xs text-neutral-400">
                            For your security, transaction data is automatically deleted after 48
                            hours.
                            <br />
                            Need help? Please contact our{" "}
                            <a
                                href="https://x.com/LibertySwapFi"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-amber-500 hover:text-amber-400 underline"
                            >
                                Support Team 24/7
                            </a>
                        </div>
                    </div>
                </div>
            </main>
            <TokenSelector
                full={false}
                open={tokenSelectorOpen}
                listMode={tokenPickerField === 'pay' ? 'default' : 'pulse'}
                onClose={() => setTokenSelectorOpen(false)}
                onSelect={(sel) => {
                    const next = {
                        symbol: sel.symbol,
                        chain: sel.chain,
                        image: sel.image,
                        chainBadge: sel.chainBadge,
                        showRailgunSuffix: false,
                    }
                    if (tokenPickerField === 'pay') {
                        setPayToken(next)
                    } else {
                        setReceiveToken(next)
                    }
                }}
            />
        </>
    )
}

export default PrivateExchange